import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-food-order-tall.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const DiningHallPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page diningHallPage">
        <Header />
        <div className="page-header">Campus Dining</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Dining Hall</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Keep staff informed of student's seating choices, 
            food preferences, allergies, and more.{'\n\n'}

            Technology enables fast, fresh, convenient 
            delivery of food, while supporting rotating and 
            flexible menus.{'\n\n'}

            Grab-and-go food and beverage options including 
            mobile barcode scanning with advanced self-service 
            check-out.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Campus Dining - Dining Hall", "InfoGenesis");
              addFlow("InfoGenesis");
              navigate("/solutions/info-genesis");
            }}
          >
            <div className="item-head">
              <LogoMini />
              InfoGenesis
            </div>
            <img src={InfoGenesis} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Campus Dining - Dining Hall", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
            <img src={IGOnDemand} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Campus Dining - Dining Hall", "IG Kiosk");
              addFlow("IG Kiosk");
              navigate("/solutions/ig-kiosk");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Kiosk
            </div>
            <img src={IGKiosk} alt="" />
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Campus Dining - Dining Hall", "IG Digital Menu Board");
              addFlow("IG Digital Menu Board");
              navigate("/solutions/digital-menu");
            }}
          >
            <div className="item-head">
              <LogoMini />
              IG Digital Menu Board
            </div>
            <img src={DigitalMenu} alt="" />
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default DiningHallPage;